export const StorePaymentMethod = {
  Cash: 'Cash',
  Card: 'Card',
  Transfer: 'Transfer',
  MbWay: 'MbWay',
  Other: 'Other',
  Online: 'Online',
};

export const IN_STORE_PAYMENT_METHODS = [
  StorePaymentMethod.Cash,
  StorePaymentMethod.Card,
  StorePaymentMethod.Transfer,
  StorePaymentMethod.MbWay,
  StorePaymentMethod.Other,
];

export const ALL_STORE_PAYMENT_METHODS = [
  ...IN_STORE_PAYMENT_METHODS,
  StorePaymentMethod.Online,
];

export const STORE_PAYMENT_METHOD_KEYS = {
  [StorePaymentMethod.Cash]: 'cash',
  [StorePaymentMethod.Card]: 'card',
  [StorePaymentMethod.Transfer]: 'transfer',
  [StorePaymentMethod.MbWay]: 'mbWay',
  [StorePaymentMethod.Other]: 'other',
  [StorePaymentMethod.Online]: 'online',
};

export const getStorePaymentMethodKey = (method) => (
  STORE_PAYMENT_METHOD_KEYS[method] || String(method || 'unknown').toLowerCase()
);

export default StorePaymentMethod;
